import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LocalStorageAPI from "../api/localStorageApi";
import { LinkPage } from "../types/Link";

const Home: React.FC = () => {
  const [linkPages, setLinkPages] = useState<LinkPage[]>([]);
  const [deletingItemId, setDeletingItemId] = useState<string | null>(null);

  useEffect(() => {
    const fetchLinkPages = async () => {
      const response = await LocalStorageAPI.getLinkPages();
      setLinkPages(response);
    };

    fetchLinkPages();
  }, []);

  const handleDeleteClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    itemId: string
  ) => {
    if (deletingItemId === itemId) {
      // Delete the item if the delete button was clicked twice
      LocalStorageAPI.deleteLinkPage(itemId);
      setLinkPages((prevLinkPages) =>
        prevLinkPages.filter((linkPage) => linkPage.Stub !== itemId)
      );
      setDeletingItemId(null);
    } else {
      // Show the delete confirmation button for the selected item
      setDeletingItemId(itemId);
    }
  };

  return (
    <div>
      <Link to={`page/new`}>
        <button className="bg-zinc-700 hover:bg-zinc-600 text-white font-semibold py-2 px-4 rounded w-full mb-6">
          New link page
        </button>
      </Link>
      <ul>
        {linkPages.map((linkPage) => (
          <li
            key={linkPage.Name}
            className="border-b border-gray-300 flex items-center justify-between block  w-full text-gray-700 hover:bg-gray-200"
          >
            <Link to={`page/${linkPage.Stub}`} className="block grow py-4 px-2">
              {linkPage.Name}
            </Link>
            {(!deletingItemId || deletingItemId !== linkPage.Stub) && (
              <button
                className="text-gray-500 text-xs grayscale py-4 px-2"
                onClick={(event) => handleDeleteClick(event, linkPage.Stub)}
              >
                ❌
              </button>
            )}
            {deletingItemId === linkPage.Stub && (
              <button
                className="text-red-500"
                onClick={(event) => handleDeleteClick(event, linkPage.Stub)}
              >
                Delete page?
              </button>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Home;
